import React from 'react';
import GlobalContextWrapper from 'utilities/GlobalContextWrapper';
import { useAppHeight } from 'utilities/useAppHeight';
import ReactGA from 'react-ga4';
import AuthenticatedApp from './components/AuthenticatedApp';
// eslint-disable-next-line import/order
import Routes from 'screens/Routes';
import Background from './components/Background';

export default function App() {
    useAppHeight();
    ReactGA.initialize('G-PCSWMWT9HL');

    return (
        <AuthenticatedApp>
            <GlobalContextWrapper>
                <Background>
                    <Routes />
                </Background>
            </GlobalContextWrapper>
        </AuthenticatedApp>
    );
}
